import React from "react";

/**
 * Pill-style filter chip. Multi-select friendly.
 * Passing an icon component renders it before the label.
 */
export default function FilterChip({
    active = false,
    onClick,
    icon: Icon = null,
    children,
    count = null,
    disabled = false,
    tone = "neutral",
    testid,
}) {
    const base =
        "inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full text-[11px] font-medium border transition-colors disabled:opacity-40 disabled:cursor-not-allowed";
    const toneMap = {
        neutral: active
            ? "bg-[#131B2F] text-white border-[#131B2F]"
            : "bg-white text-[#131B2F] border-[#E5E7EB] hover:border-[#131B2F]",
        green: active
            ? "bg-[#3E9E2E] text-white border-[#3E9E2E]"
            : "bg-white text-[#2E7E22] border-[#E5E7EB] hover:border-[#3E9E2E]",
        amber: active
            ? "bg-[#B45309] text-white border-[#B45309]"
            : "bg-white text-[#B45309] border-[#E5E7EB] hover:border-[#B45309]",
        red: active
            ? "bg-[#991B1B] text-white border-[#991B1B]"
            : "bg-white text-[#991B1B] border-[#E5E7EB] hover:border-[#991B1B]",
    };
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            data-testid={testid}
            aria-pressed={active}
            className={`${base} ${toneMap[tone] || toneMap.neutral}`}
        >
            {Icon && <Icon size={12} strokeWidth={2} />}
            <span>{children}</span>
            {count !== null && count !== undefined && (
                <span
                    className={`ml-0.5 min-w-[16px] h-4 px-1 rounded-full text-[10px] font-semibold flex items-center justify-center ${
                        active ? "bg-white/25" : "bg-[#F5F5F7] text-[#4B5565]"
                    }`}
                >
                    {count}
                </span>
            )}
        </button>
    );
}
